document.addEventListener("DOMContentLoaded", function () {
  var accordionButtons = document.querySelectorAll(
    ".c_accordion_unit .c_accordion_button"
  );

  if (!accordionButtons.length) return;

  accordionButtons.forEach(function (button, index) {
    var unit = button.closest(".c_accordion_unit");
    if (!unit) return;

    var content = unit.querySelector(".c_accordion_content");
    if (!content) return;

    // コンテンツに一意のIDを設定（まだ設定されていない場合）
    if (!content.id) {
      content.id = "accordion-content-" + index;
    }

    // ボタンにaria属性を設定
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", content.id);
    button.setAttribute("role", "button");

    // コンテンツにaria-hidden属性を設定（初期状態は非表示）
    content.setAttribute("aria-hidden", "true");

    // クリックイベント
    button.addEventListener("click", function () {
      var isOpen = content.classList.contains("-open");

      if (isOpen) {
        // 閉じる
        content.classList.remove("-open");
        unit.classList.remove("-open");
        button.setAttribute("aria-expanded", "false");
        content.setAttribute("aria-hidden", "true");
      } else {
        // 開く
        content.classList.add("-open");
        unit.classList.add("-open");
        button.setAttribute("aria-expanded", "true");
        content.setAttribute("aria-hidden", "false");
      }
    });
  });
});
